import { trackPDP } from 'apps/variants/track_events';
import 'pages/starter-kit';
trackPDP();
